import {
  Table as TableAdminUI,
  TBody,
  TBodyRow,
  TBodyCell,
  THead,
  THeadCell,
  TableColumn,
  TableProps,
  TableBodyCellProps,
  TableHeadCellProps,
} from '@vtex/admin-ui';
import styles from './style.module.css';

type Props<T> = {
  data: T[];
  columns: TableColumn<T>[];
  withoutHead?: boolean;
  getBodyCell: (column: TableColumn<T>, item: T) => TableBodyCellProps<T>;
  getHeadCell?: (column: TableColumn<T>) => TableHeadCellProps<T>;
  getTable: () => TableProps<T>;
};

export const Table = <T,>({
  data,
  columns,
  withoutHead,
  getBodyCell,
  getHeadCell,
  getTable,
}: Props<T>) => {
  return (
    <TableAdminUI {...getTable()} className={styles.container}>
      {!withoutHead && getHeadCell && (
        <THead>
          {columns.map(column => {
            const { key, ...headCellProps } = getHeadCell(column);
            return <THeadCell key={key} {...headCellProps} />;
          })}
        </THead>
      )}
      <TBody>
        {data.map((item, itemIndex) => (
          <TBodyRow key={itemIndex}>
            {columns.map(column => {
              const { key, ...bodyCellProps } = getBodyCell(column, item);
              return <TBodyCell key={key} {...bodyCellProps} />;
            })}
          </TBodyRow>
        ))}
      </TBody>
    </TableAdminUI>
  );
};
